module.exports = __webpack_public_path__ + "img/ch51.96f73688.png";